import { configureStore } from '@reduxjs/toolkit';
import { authorizedApi } from '@/redux/api/authorized/index.js';
import { publicApi } from '@/redux/api/public/index.js';
import { privyApi } from '@/redux/api/authorized/privy.js';
import errorSnack from '@/redux/slices/errorSnack.js';
import modals from '@/redux/slices/modals.js';
import auth from '@/redux/slices/auth.js';
import customizeCard from '@/redux/slices/customizeCard.js';
import wallet from '@/redux/slices/walletSlice';
import tokens from '@/redux/slices/tokenSlice';
import theme from '@/redux/slices/themeSlice';

export const store = configureStore({
  reducer: {
    [authorizedApi.reducerPath]: authorizedApi.reducer,
    [publicApi.reducerPath]: publicApi.reducer,
    [privyApi.reducerPath]: privyApi.reducer,
    auth,
    errorSnack,
    modals,
    customizeCard,
    wallet,
    tokens,
    theme,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authorizedApi.middleware,
      publicApi.middleware,
      privyApi.middleware,
    ),
});
